import { API } from '@eservices/shared/type';
import { Space } from 'antd';
import React from 'react';
import { useTranslation } from '../../../../../hooks/translationHook';
import RegionButton from '../Common/RegionButton';

interface EmptyTextSplitProps {
    identifier: API.PDFSplitIdentifier;
}

const EmptyTextSplit: React.FC<EmptyTextSplitProps> = ({ identifier }) => {
    const { t } = useTranslation('workflow');

    return (
        <Space>
            {t('split_overview_part1')}
            <RegionButton regionOfInterest={identifier.regionOfInterest} />
            <strong>{t('split_overview_empty_text_part2')}</strong>
        </Space>
    );
};

export default EmptyTextSplit;
